module.exports = __webpack_public_path__ + "static/media/YB5F09_2.fd13a935.jpg";